import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { saveSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/accedi", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        saveSession(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      })
      .catch(() => {
        toast.error("Accesso con Google non riuscito");
        navigate("/accedi", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="text-volt animate-spin" size={32} />
    </div>
  );
}
